module.exports = __webpack_public_path__ + "files/f6f74ea49942ce2602fc5a21b0861b5a.png";